import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {ModelsService} from '@irb/irb-models/models-new/models.service';
import {IrbModelsEvents} from '@irb/irb-models/irb-models.events';
import {EditorMmcModelService} from '@irb/irb-editors/editor-mmc-model/editor-mmc-model.service';
import {IrbAppEvents} from '@irb/app.events';
import {IAlertDialogData} from '@irb/app.model';

@Component({ standalone: false,
    selector: 'irb-mmc-import-model-target',
    templateUrl: './mmc-import-model-target.component.html',
    styleUrls: ['./mmc-import-model-target.component.scss', '../../../irb-common/styles/dialog.scss']
})
export class MmcImportModelTargetComponent implements OnInit {

    file: any;
    hasFile: boolean = false;
    isValidFile: boolean = false;
    errorMessage: string;
    showErrorsView: boolean = false;
    errorRowData: any;
    gridOptions: any;
    erorGridHeight: string = '100px';

    constructor(
        public dialogRef: MatDialogRef<MmcImportModelTargetComponent>,
        public as: AppService,
        public modelsService: ModelsService,
        private editorMmcModelService: EditorMmcModelService
    ) {
    }

    ngOnInit(): void {
    }

    close() {
        this.dialogRef.close();
    }

    onFileChange(event: any) {
        this.file = event.target.files[0];
        this.hasFile = true;
        this.isValidFile = this.file.name.endsWith('.csv');
        this.errorMessage = "";
        this.showErrorsView = false;
    }

    submitFile() {
          const f = new FormData();
        f.append('import-model-targets', this.file, this.file.name);

        this.editorMmcModelService.importSecurities(f).subscribe({
            next: (response: any) => {
                response = JSON.parse(response);

                if (response.responseStatus === 'ERROR') {
                    this.getErrorDataPrepared(response);
                    return;
                }
                if (response.responseStatus === 'SUCCESS') {
                    this.showErrorsView = false;
                    if (response.responseData) {
                        const newRecs = response.responseData.validSecurityList ? response.responseData.validSecurityList : [];

                        if (response.responseData && response.responseData.moneyMarketSecurityList && response.responseData.moneyMarketSecurityList.length !== 0) {
                            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                                dTitle: "Alert",
                                msg: "Account sweeps cannot be added to models in the Market Center.",
                                altMsg: "If you wish to enter a cash position in your model, use the symbol $CASH. The sweep money market held in a client's account will be determined by Relationship Manager.",
                                dProceedBtnLabel: "Close",
                            } as IAlertDialogData);
                        }
                        if (newRecs.length !== 0) {
                            this.editorMmcModelService.addNewTargets(newRecs);
                        }
                    }
                }
                this.close();
            }, error: () => {}
          });
    }

    private getErrorDataPrepared(response: any) {
        this.errorRowData = [];
        if (response.responseData && response.responseData.errorMessages && response.responseData.errorMessages.length !== 0) {
            const errorMap: any = {
                'Targets do not equal 100%': 'Sum of target allocations does not equal 100%',
                'Target value is not valid': 'Target value is invalid (negative value, more than 1 decimal entered, special characters)',
                'Unrecognized security': 'Contact your Relationship Manager to get the security added',
                'Missing data': 'Symbol or Target is missing',
                'Missing data - symbol': 'Symbol is missing',
                'Missing data - target': 'Target is missing'
            };

            let errItem: any, errExpl: string;
            response.responseData.errorMessages.forEach((err: string) => {
                errExpl = null;
                errExpl = errorMap[err];
                if (errExpl) {
                    errItem = {
                        errorCondition: err,
                        explanation: errExpl
                    };
                    this.errorRowData.push(errItem);
                }
            });
        }
        if (this.errorRowData.length === 0) {
            this.errorRowData = [
                {
                    errorCondition: 'Invalid file format.',
                    explanation: 'Invalid file format.'
                }
            ];
        }

        const colDefs = [
            {
                headerName: 'Error Condition',
                field: 'errorCondition',
                sortable: false,
                suppressMovable: true,
                minWidth: 110,
                flex: 3,
                cellRenderer: 'cellRendererFormatter',
                lockPosition: true
            },
            {
                headerName: 'Explanation',
                field: 'explanation',
                sortable: false,
                suppressMovable: true,
                cellRenderer: 'cellRendererFormatter',
                minWidth: 320,
                flex: 1
            }
        ];
        this.gridOptions = {
            columnDefs: colDefs,
            floatingFilter: false
        };
        this.erorGridHeight = this.errorRowData.length * 30 + 33 + 'px';
        this.dialogRef.updateSize("750px", "auto");
        this.showErrorsView = true;

    }

}
